var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"p-3 p-xl-5",domProps:{"innerHTML":_vm._s(_vm.terms)}})])}
var staticRenderFns = []

export { render, staticRenderFns }